module.exports = __webpack_public_path__ + "static/media/dashcamdetails.ef9c7f7e.png";